function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { COLUMNS_IDS, INT_TO_ID_MAP } from "./consts";
import AssetComponent from "/components/core/asset/asset-component";
import pickBy from "lodash/pickBy";
import { APPS_NEW, APPS_RECOMMENDED, APPS_TRENDING } from "./consts";
const WEBSITE_LOCATION_ID = 2;
const getColumnValueById = (item, id)=>{
    var _item_column_values_find;
    const columnValue = (_item_column_values_find = item.column_values.find((columnItem)=>columnItem.id === id)) === null || _item_column_values_find === void 0 ? void 0 : _item_column_values_find.value;
    return columnValue ? JSON.parse(columnValue) : null;
};
const formatDate = (dateString, format)=>{
    if (!dateString || dateString === "") {
        return "";
    }
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    return new Intl.DateTimeFormat("en-US", format).format(date);
};
const getDate = (item, format)=>{
    var _getColumnValueById;
    const dateValue = (_getColumnValueById = getColumnValueById(item, COLUMNS_IDS.DATE)) === null || _getColumnValueById === void 0 ? void 0 : _getColumnValueById.date;
    return formatDate(dateValue, format) || "";
};
const getFullDate = (item)=>{
    return getDate(item, {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
};
const getMonthYearDate = (item)=>{
    return getDate(item, {
        month: "long",
        year: "numeric"
    });
};
const getPartialDate = (item)=>{
    return getDate(item, {
        month: "long",
        day: "numeric"
    });
};
const getMonthDate = (item)=>{
    return getDate(item, {
        month: "long"
    });
};
const getUrl = (item, id)=>{
    var _getColumnValueById;
    return (_getColumnValueById = getColumnValueById(item, id)) === null || _getColumnValueById === void 0 ? void 0 : _getColumnValueById.replace(/^"|"$/g, "");
};
export const createItemsArray = (items)=>{
    const itemsArray = [];
    const releaseHighlightsArray = [];
    const appsSet = {
        [APPS_NEW]: {
            tabLabel: "New",
            content: []
        },
        [APPS_RECOMMENDED]: {
            tabLabel: "Recommended",
            content: []
        },
        [APPS_TRENDING]: {
            tabLabel: "Trending",
            content: []
        }
    };
    const monthlyVideosSet = new Map();
    items === null || items === void 0 ? void 0 : items.forEach((item)=>{
        var _item_column_values_find_value, _item_column_values_find, _item_column_values, _getColumnValueById, _getColumnValueById1, _getColumnValueById2, _getColumnValueById3;
        const title = item === null || item === void 0 ? void 0 : (_item_column_values = item.column_values) === null || _item_column_values === void 0 ? void 0 : (_item_column_values_find = _item_column_values.find((columnItem)=>columnItem.id === COLUMNS_IDS.TITLE)) === null || _item_column_values_find === void 0 ? void 0 : (_item_column_values_find_value = _item_column_values_find.value) === null || _item_column_values_find_value === void 0 ? void 0 : _item_column_values_find_value.replace(/"/g, "");
        const shortText = ((_getColumnValueById = getColumnValueById(item, COLUMNS_IDS.SHORT_TEXT)) === null || _getColumnValueById === void 0 ? void 0 : _getColumnValueById.text) || "";
        const releaseTypeIndex = (_getColumnValueById1 = getColumnValueById(item, COLUMNS_IDS.RELEASE_TYPE)) === null || _getColumnValueById1 === void 0 ? void 0 : _getColumnValueById1.index;
        const releaseType = INT_TO_ID_MAP.releaseType[releaseTypeIndex];
        const planIndex = (_getColumnValueById2 = getColumnValueById(item, COLUMNS_IDS.PLAN)) === null || _getColumnValueById2 === void 0 ? void 0 : _getColumnValueById2.index;
        const plan = INT_TO_ID_MAP.plan[planIndex];
        const fullDate = getFullDate(item);
        const monthYearDate = getMonthYearDate(item);
        const partialDate = getPartialDate(item);
        const monthDate = getMonthDate(item);
        const locationIndices = (_getColumnValueById3 = getColumnValueById(item, COLUMNS_IDS.LOCATION)) === null || _getColumnValueById3 === void 0 ? void 0 : _getColumnValueById3.ids;
        const isWebsiteLocation = locationIndices === null || locationIndices === void 0 ? void 0 : locationIndices.includes(WEBSITE_LOCATION_ID);
        const monthlyVideoId = getUrl(item, COLUMNS_IDS.MONTHLY_VIDEO_ID);
        if (monthlyVideoId) {
            monthlyVideosSet.set(monthYearDate, monthlyVideoId);
        }
        const readyToPost = getColumnValueById(item, COLUMNS_IDS.READY_TO_POST);
        if (!readyToPost || readyToPost.index !== 105) {
            return;
        }
        const isValid = title && shortText && releaseType && fullDate && isWebsiteLocation;
        if (isValid) {
            var _getColumnValueById4, _getColumnValueById5, _getColumnValueById6, _getColumnValueById7, _getColumnValueById8, _getColumnValueById9;
            const productIndex = (_getColumnValueById4 = getColumnValueById(item, COLUMNS_IDS.PRODUCT)) === null || _getColumnValueById4 === void 0 ? void 0 : _getColumnValueById4.ids;
            const teamIndex = (_getColumnValueById5 = getColumnValueById(item, COLUMNS_IDS.TEAM)) === null || _getColumnValueById5 === void 0 ? void 0 : _getColumnValueById5.index;
            const releaseStatusIndex = (_getColumnValueById6 = getColumnValueById(item, COLUMNS_IDS.RELEASE_STATUS)) === null || _getColumnValueById6 === void 0 ? void 0 : _getColumnValueById6.index;
            const releaseHighlightsIndex = (_getColumnValueById7 = getColumnValueById(item, COLUMNS_IDS.RELEASE_HIGHLIGHTS)) === null || _getColumnValueById7 === void 0 ? void 0 : _getColumnValueById7.index;
            const benefitIndices = (_getColumnValueById8 = getColumnValueById(item, COLUMNS_IDS.BENEFIT)) === null || _getColumnValueById8 === void 0 ? void 0 : _getColumnValueById8.ids;
            const articleLink = ((_getColumnValueById9 = getColumnValueById(item, COLUMNS_IDS.ARTICLE_LINK)) === null || _getColumnValueById9 === void 0 ? void 0 : _getColumnValueById9.url) || "";
            const product = productIndex === null || productIndex === void 0 ? void 0 : productIndex.map((productInd)=>{
                return INT_TO_ID_MAP.product[productInd];
            });
            const team = INT_TO_ID_MAP.team[teamIndex];
            const releaseStatus = INT_TO_ID_MAP.releaseStatus[releaseStatusIndex];
            const cloudinaryUrl = getUrl(item, COLUMNS_IDS.CLOUDINARY_IMG_URL);
            const isReleaseHighlight = INT_TO_ID_MAP.releaseHeighlights[releaseHighlightsIndex];
            const benefit = benefitIndices ? benefitIndices.map((benefitIndex)=>INT_TO_ID_MAP.benefit[benefitIndex]) : [];
            const newItem = {
                title,
                shortText,
                product,
                releaseType,
                team,
                releaseStatus,
                plan,
                benefit,
                cloudinaryUrl,
                articleLink,
                fullDate,
                partialDate,
                monthDate,
                monthYearDate
            };
            if (releaseType === APPS_NEW || releaseType === APPS_RECOMMENDED || releaseType === APPS_TRENDING) {
                var _appsSet_releaseType_content, _appsSet_releaseType;
                (_appsSet_releaseType = appsSet[releaseType]) === null || _appsSet_releaseType === void 0 ? void 0 : (_appsSet_releaseType_content = _appsSet_releaseType.content) === null || _appsSet_releaseType_content === void 0 ? void 0 : _appsSet_releaseType_content.push(newItem);
                return;
            }
            if (isReleaseHighlight) {
                releaseHighlightsArray.push(newItem);
            } else {
                itemsArray.push(newItem);
            }
        }
    });
    return {
        itemsArray,
        releaseHighlightsArray,
        monthlyVideosSet,
        appsSet
    };
};
export const filterItems = (items, filters, textSearch)=>{
    return items.filter((item)=>{
        var _item_title_toLowerCase, _item_title, _item_description_toLowerCase, _item_description;
        return Object.entries(filters).every(([id, filter])=>{
            if (Array.isArray(item[id])) {
                return filter.length === 0 || item[id].some((value)=>filter.includes(value));
            }
            return filter.length === 0 || filter.includes(item[id]);
        }) && (textSearch === "" || (item === null || item === void 0 ? void 0 : (_item_title = item.title) === null || _item_title === void 0 ? void 0 : (_item_title_toLowerCase = _item_title.toLowerCase()) === null || _item_title_toLowerCase === void 0 ? void 0 : _item_title_toLowerCase.includes(textSearch.toLowerCase())) || (item === null || item === void 0 ? void 0 : (_item_description = item.description) === null || _item_description === void 0 ? void 0 : (_item_description_toLowerCase = _item_description.toLowerCase()) === null || _item_description_toLowerCase === void 0 ? void 0 : _item_description_toLowerCase.includes(textSearch.toLowerCase())));
    });
};
export const getReleaseTypeIcon = (releaseType)=>{
    const releaseTypeIconMap = {
        New_release: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/feature_release_icon.svg",
        Bug_fix: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/bug_fix_icon.svg",
        Performance: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/performance_icon2.svg",
        Event: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/event_icon.svg",
        Announcement: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/announcement_icon.svg",
        Feature_upgrade: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/new_feature_upgrade_icon.svg",
        Apps_and_integrations: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/new_apps_integration_icon.svg",
        Gradual_release: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/sprout.svg"
    };
    return Object.keys(releaseTypeIconMap).includes(releaseType) ? /*#__PURE__*/ _jsx("div", {
        className: "icon",
        children: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: releaseTypeIconMap[releaseType]
            }
        })
    }) : null;
};
export const getFilterIcon = (name)=>{
    const filterIconMap = {
        "monday CRM": /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/crm.svg"
            }
        }),
        "monday dev": /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/dev.svg"
            }
        }),
        WorkCanvas: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/canvas.png"
            }
        }),
        WorkForms: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/workforms.svg"
            }
        }),
        "monday work management": /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/wm.svg"
            }
        }),
        "monday service": /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/monday_platform/product-solutions/product-icons/service-logo-dec2023.svg"
            }
        })
    };
    return Object.keys(filterIconMap).includes(name) ? /*#__PURE__*/ _jsx("div", {
        className: "icon",
        children: filterIconMap[name]
    }) : null;
};
export const getCleanedFilterSchema = (filtersSchema, itemsArray)=>{
    return filtersSchema.map((filterSchemaItem)=>{
        const filterValues = itemsArray.flatMap((item)=>{
            const value = item[filterSchemaItem.id];
            return Array.isArray(value) ? value : [
                value
            ];
        });
        const filterSchemeItemIds = [
            ...new Set(filterValues)
        ];
        return _object_spread_props(_object_spread({}, filterSchemaItem), {
            data: pickBy(filterSchemaItem.data, (value, key)=>{
                return filterSchemaItem.id === "benefit" || filterSchemeItemIds.includes(key);
            })
        });
    }).filter((filter)=>Object.keys(filter.data).length > 1);
};
export const PRODUCT_TAG_TYPE = "product";
export const RELEASE_TYPE_TAG_TYPE = "releaseType";
export const TEAM_TAG_TYPE = "team";
export const RELEASE_STATUS_TAG_TYPE = "releaseStatus";
export const PLAN_TAG_TYPE = "plan";
export const BENEFIT_TAG_TYPE = "benefit";
